import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Link } from 'react-router-dom';

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const slideDown = keyframes`
  from { transform: translateY(-8px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  animation: ${fadeIn} 0.18s ease;

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding-top: 56px;
  }
`;

export const ModalPanel = styled.div`
  width: 100%;
  max-width: 680px;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: ${slideDown} 0.2s ease;

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    max-width: 100%;
    border-radius: 0 0 12px 12px;
  }
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.sm};
  padding: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.lg};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.color};
`;

export const SearchIconWrapper = styled.div`
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.text.tertiary};
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ModalInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  color: ${({ theme }) => theme.colors.text.primary};
  background: transparent;

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
`;

export const CloseButton = styled.button`
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${({ theme }) => theme.space.xs};
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.radius.sm};
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ResultsContainer = styled.div`
  max-height: 420px;
  overflow-y: auto;
`;

export const ResultItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.md};
  padding: ${({ theme }) => theme.space.sm} ${({ theme }) => theme.space.lg};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.text.primary};
  transition: background 0.12s;

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.color};
  }
`;

export const ResultImage = styled.img`
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.radius.sm};
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.background.secondary};
`;

export const ResultImagePlaceholder = styled.div`
  width: 52px;
  height: 52px;
  border-radius: ${({ theme }) => theme.radius.sm};
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.background.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.tertiary};
`;

export const ResultInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultTitle = styled.p`
  margin: 0 0 2px;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.demi};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ResultPrice = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ModalFooter = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.border.color};
  padding: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.lg};
  text-align: center;
`;

export const ViewAllLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.demi};
  color: ${({ theme }) => theme.colors.text.primary};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.7;
  }
`;

export const StatusMessage = styled.div`
  padding: ${({ theme }) => theme.space['2xl']};
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
`;
